import { Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

export const StowageInstructionHeader = () => {
  const { t } = useTranslate()
  const navigate = useNavigate()
  const title = t('Stowage Instructions', 'Stowage Instructions')
  const breadcrumbs = [
    { label: t(PATHS.masterData.title), route: PATHS.masterData.url },
    {
      label: title,
    },
  ]

  return (
    <Header
      title={title}
      position='relative'
      breadcrumbs={breadcrumbs}
      rightRenderOption={
        <Button
          sx={{ flex: 'none' }}
          variant='contained'
          onClick={() => navigate('add')}
          data-cy='add-stowage-instruction-btn'
        >
          {t('addStowageInstruction', 'Add stowage instruction')}
        </Button>
      }
    />
  )
}
